import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_TECHNOLOGIES } from "app/pages/sales-intelligence/constants/routes";
import useTechnologiesQuery from "app/pages/sales-intelligence/modules/company-analysis/queries/useTechnologiesQuery";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import TechnologiesCardContent from "app/pages/sales-intelligence/pages/company-analysis/components/cards/technologies-card/TechnologiesCardContent/TechnologiesCardContent";
import TechnologiesCardLoader from "app/pages/sales-intelligence/pages/company-analysis/components/cards/technologies-card/TechnologiesCardLoader/TechnologiesCardLoader";
import Card from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/Card";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { COMPANY_ANALYSIS_TAB_NAMES } from "app/pages/sales-intelligence/pages/company-analysis/constants";
import { useCompanyName } from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCompanyName";

const TechnologiesCard = () => {
    const { data, isLoading, isFetched } = useTechnologiesQuery();
    const isEmpty = (!data || data.length === 0) && isFetched;

    const companyName = useCompanyName();

    const renderContent = () => {
        if (isLoading) {
            return <TechnologiesCardLoader />;
        }

        return (
            <Flex
                justifyContent="flex-start"
                flexGrow="1"
                flexDirection="column"
                flexWrap="wrap"
                padding="8px 24px"
                gap="8px"
                minHeight="316px"
            >
                <TechnologiesCardContent technologies={data} />
            </Flex>
        );
    };

    return (
        <Card
            dataAutomation="technologies-card"
            isEmpty={isEmpty}
            header={
                <CardHeader
                    title={translate("si.company-analysis.technologies.card.header")}
                    infoTooltip={translate("si.company-analysis.technologies.card.header.info-tooltip")}
                />
            }
            footer={
                <CardFooter
                    stateId={COMPANY_ANALYSIS_TECHNOLOGIES}
                    isLoading={isLoading}
                    onClick={() => {
                        companyAnalysisTrackingService.widgets.trackWidgetFooterButtonClick(
                            companyName,
                            COMPANY_ANALYSIS_TAB_NAMES.technologies,
                        );
                    }}
                />
            }
            renderContent={renderContent}
            width="50%"
        />
    );
};

export default TechnologiesCard;
